module.exports = __webpack_public_path__ + "assets/sales-c6d696b531b9ee677040c504df524564.svg";